import React, {useContext, useEffect, useRef, useState} from 'react'
import sdkForms, {ErrorList, fields, widgets} from '@eforms/sdk-json-forms'
import Form from 'react-jsonschema-form'
import {getThemesByBrand, sendFeedbackApi, useForm, useSubmitForm} from '../utils/hooks'
import {Notification} from '@zambezi/sdk/notification'
import validateFormData from 'react-jsonschema-form/lib/validate';
import {isObject} from "react-jsonschema-form/lib/utils";

import {Icon} from "@zambezi/sdk/icons";
import applyRules from 'react-jsonschema-form-conditionals';
import Engine from 'json-rules-engine-simplified';
import "./GenericForm.css";
import request from '../utils/request';
import '@zambezi/css-helpers/css/helpers.css';
import {Engine as JsonEngine} from 'json-rules-engine';
import {cloneDeep, omit, set} from 'lodash';
import {Modal} from "@zambezi/sdk/modal";
import ScreenRenderingAssistant from './utils/ScreenRenderingAssistant';
import {useDispatch, useSelector} from 'react-redux';
import {analyticsSubmitDefinition, updateFormDataTag} from '../redux/analyticsSlice';
import {
    analyticsApplicationComplete,
    analyticsApplicationStepName,
    onAnalyticsApplicationSubmit,
    setLabelAndValue,
    setTaggingData,
    updateAnalyticInput,
    updateAnalyticsCheckBox,
    updateAnalyticsDateField,
    updateAnalyticsDropDown,
    updateAnalyticsErrorMessage,
    updateAnalyticsEsign,
    updateAnalyticsFeedbackStar,
    updateAnalyticsHint,
    updateAnalyticsPostcode,
    updateAnalyticsRadioButton,
    updateAnalyticsTextArea
} from './analyticsTrack'
import {
    ANALYTICS_CHECKBOX,
    ANALYTICS_CHECKBOXNAME,
    ANALYTICS_CHECKBOXOPTION,
    ANALYTICS_DATE,
    ANALYTICS_DROPDOWN_LABEL_AND_VALUE,
    ANALYTICS_ESIGN,
    ANALYTICS_FEEDBACK,
    ANALYTICS_FEEDBACKNAME,
    ANALYTICS_FEEDBACKOPTION,
    ANALYTICS_HINT_TEXT,
    ANALYTICS_INPUT_LABEL_AND_VALUE,
    ANALYTICS_POSTCODE_LABEL,
    ANALYTICS_RADIO_LABEL_AND_VALUE,
    ANALYTICS_SUMMARY,
    ANALYTICS_TEXTAREA,
    FEEDBACK_SUBMIT_ACKNOWLWDGEMENT,
    FORM_SUBMIT_ACKNOWLEDGEMENT,
    THANK_YOU_PAGE_TEXT
} from '../constants/Constants'
import {
    customFormats,
    Footer,
    getBrand,
    getCurrentStepFormData,
    isArrEmpty,
    isObjectEmpty,
    isStrEmpty,
    validateformDefinition,
    focusFirstErrorField,
    removeDefaultProperties,
    doesFormContainSummary
} from '@eforms/forms-common-ui';
import {WIDGET_SUMMARY} from "../constants/widgets";
import { AuthenticationContext, AUTHENTICATION_STATUS } from "./Authentication/IAMAuthentication";
import { getAccessToken } from "../utils/authUtils";
import { getBrandDetails } from "../utils/getBrandDetails";
import LimitedTimeWarningModal from "./LimitedTimeWarningModal";
import IdleFormExpiryModal from "./IdleFormExpiryModal";
import './Header.css';
import './Footer.css';
import './Stepper.css';
import './SaveNotification.css';
import { FORM_FEEDBACK_SAVE } from '../constants/ApiEndPoint'

let FormWithConditionals = () => null;

export default function GenericForm(props) {
    let uuid = props.match.params.uuid;
    const formId = props.match.params.formId;
    let stepName = props.match.params.stepName;

    const { authenticationDetails, updateAuthenticationDetails, renewalTimerId } = useContext(AuthenticationContext);
    const { authenticationStatus, showLimitedTimeWarning, authenticationError } = authenticationDetails;


    const {
      isLoading: isSchemaLoading,
      formDefinition,
      formData,
      error: schemaError,
      customerDetails,
    } = useForm(uuid,{ "allow-templates": false }, authenticationStatus);
    
    const [
        state,
        setState
    ] = useState({ isDataSaved: false, ishideSteps: false, isRulesByBrand: false, isUpdateSubmitForm: false, isLiveValidate: false, activeStep: 0, payloadData: { data: {} }, thankyou: {}, completedStep: false, removedSteps: [], isShowButton: false, isThankyouPage: false, isOpen: true, isModelOpen: false, parentUuid: '' })
    window.state = state;
    const {
        submitData,
        formState,
        activeStep,
        isDataSaved,
        payloadData,
        isOpen,
        isModelOpen,
        parentUuid,
        isLiveValidate,
        isUpdateSubmitForm,
        isRulesByBrand,
        isThankyouPage
    } = state;
    const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false);
    const defaultBasicTag = useSelector((state) => state.analytics.defaultBasicTag);
    const submitDataTag = useSelector((state) => state.analytics.submitDataTag);
    const formDataTag = useSelector((state) => state.analytics.formDataTag);
    const [ishideSteps, setIsHideStep] = useState( false );
    const [removedSteps, setRemovedSteps] = useState( [] );
    const [customFieldArrayItemSchemaOverrides,setCustomFieldArrayItemSchemaOverrides] = useState();
    const [updatedSubmitTag, setUpdatedSubmitTag] = useState(defaultBasicTag);

    const [noOfColumnsForStepper, setNoOfColumnsForStepper] = useState(3);
    const [noOfColumnsForForm, setNoOfColumnsForForm] = useState(9);
    const [brandDetails,setBrandDetails] = useState({});
    const [formSubmitted,setFormSubmitted] = useState(false);
    const [thankyouPagePayloadData, setThankyouPagePayloadData] = useState({});
    const [isSendFeedback, setIsSendFeedback] = useState(false);
    const [sendFeedbackApiState, setSendFeedbackApiState] = useState({
        isSaving: false,
        error: null,
        response: undefined
      });
    /**
     * This state stores and gets gets updated with fields of hiddenSteps so that whenver step is visible again
     * we can retain data entered by customer before the step was hidden in the newly visible step.
    */
    const [dataDictionary, setDataDictionary]=useState({});
    const dispatch = useDispatch();
    const { response } = useSubmitForm(submitData, isDataSaved, authenticationStatus);
    const headerRef = useRef();
    const formRef = useRef();
    const gotoStep = (stepNumber) => {
        setState(prevState => ({
            ...prevState,
            activeStep: stepNumber
        }));
    };
    const SummaryWidgetWithState = (...args) => {
        return sdkForms.SummaryWidget(args, formDefinition, payloadData, gotoStep);
    }
    const DirectDebitWidgetWithState = (...args) => {
        return sdkForms.fields.DirectDebitWidget(args, formDefinition, payloadData);
    }

    const extendedFields = {
        ...fields,
        SummaryWidget: SummaryWidgetWithState,
        DirectDebitWidget: DirectDebitWidgetWithState
    };

    const DIGITAL_DATA_VALUE_ADAPTER = window.environmentConfig.digitalDataValueAdapter;

    const analyticsEvent = (fieldType, value, newAnalyticsData, options) => {
        switch (fieldType) {
            case ANALYTICS_DATE:
                updateAnalyticsDateField(value, newAnalyticsData, options, defaultBasicTag);
                break;
            case ANALYTICS_CHECKBOX:
                updateAnalyticsCheckBox(value, newAnalyticsData, options);
                break;
            case ANALYTICS_SUMMARY:
                updateAnalyticsCheckBox(value, newAnalyticsData, options);
                break;         
            case ANALYTICS_TEXTAREA:
                updateAnalyticsTextArea(value, newAnalyticsData);
                break;
            case ANALYTICS_INPUT_LABEL_AND_VALUE:
                updateAnalyticInput(value, newAnalyticsData, options)
                break ;
            case ANALYTICS_DROPDOWN_LABEL_AND_VALUE:
                updateAnalyticsDropDown(value, newAnalyticsData, options)
                break;
            case ANALYTICS_RADIO_LABEL_AND_VALUE:
                updateAnalyticsRadioButton(value, newAnalyticsData, options)
                break; 
            case ANALYTICS_HINT_TEXT:
                updateAnalyticsHint(value, newAnalyticsData)
                break;
            case ANALYTICS_ESIGN:
                updateAnalyticsEsign(value, newAnalyticsData)
                break; 
            case ANALYTICS_POSTCODE_LABEL:
                updateAnalyticsPostcode(value, newAnalyticsData)
                break;    
            case ANALYTICS_FEEDBACK:
                updateAnalyticsFeedbackStar(value, newAnalyticsData, options, defaultBasicTag)
                break;   
            default:
                throw new Error('Unsupported field type: ' + fieldType);
        }
}

useEffect(() => {
    setUpdatedSubmitTag(submitDataTag);
    
        if(formDefinition){
            const stepName = formDefinition.stepDefinitions[activeStep].name;
            const brandName = state.payloadData.brand;
            setTaggingData(submitDataTag, defaultBasicTag, stepName, formDataTag, brandName);
        }

}, [submitDataTag])

    const handleAnalyticsChange = (options, value, fieldType) => {
        let newAnalyticsData = cloneDeep(updatedSubmitTag);
        if (fieldType.match(/Input|Radio|Dropdown/g)) {
            const key = options.digitalDataValue;
            set(newAnalyticsData, `${DIGITAL_DATA_VALUE_ADAPTER[key]}.${key}`, value);
            dispatch(analyticsSubmitDefinition(newAnalyticsData));
        }
        if (fieldType === ANALYTICS_SUMMARY || fieldType === ANALYTICS_CHECKBOX) {
            setLabelAndValue(newAnalyticsData, ANALYTICS_CHECKBOXNAME, ANALYTICS_CHECKBOXOPTION, value);
            dispatch(updateFormDataTag(newAnalyticsData));
        }
        if (fieldType === ANALYTICS_FEEDBACK) {
            setLabelAndValue(newAnalyticsData, ANALYTICS_FEEDBACKNAME, ANALYTICS_FEEDBACKOPTION, value);
            dispatch(updateFormDataTag(newAnalyticsData));
        }
        newAnalyticsData = {
            ...defaultBasicTag, ...newAnalyticsData,
            application: {
                ...defaultBasicTag.application, ...newAnalyticsData.application,
                stepName: formDefinition.stepDefinitions[activeStep].name,
                brandName: state.payloadData.brand,
                applicationType: document.title
            }
        };
        analyticsEvent(fieldType, value, newAnalyticsData, options);
    }

    useEffect(() => {
        setBrandDetails(getBrandDetails());
        const uuidRequest = request
          .get("/uuid")
          .set("Content-Type", "text/plain")
          .set("x-form-uuid", uuid);
        if (authenticationStatus === AUTHENTICATION_STATUS.SUCCESS) {
          uuidRequest.set("Authorization", `Bearer ${getAccessToken()}`);
          uuidRequest.withCredentials();
        }
        uuidRequest.then((res) =>
          setState((prevState) => ({ ...prevState, parentUuid: res.text }))
        );
    }, [])

    // resetting the state to default once UUID is updated
    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            activeStep: 0,
            formData: {},
            payloadData: { data: {} }
        }));
    }, [uuid])

    useEffect(() => {
        if (formDefinition) {
            document.title = formDefinition.isSteppedForm ? `${formDefinition.name.toUpperCase()}| ${formDefinition.stepDefinitions[activeStep].name.toUpperCase()}` : `${formDefinition.name.toUpperCase()}`
            if (stepName && formDefinition.isSteppedForm) {
                stepName = formDefinition.stepDefinitions[activeStep].name;
            }
            let ruleDefinition = formDefinition.stepDefinitions[activeStep].ruleDefinition;
            let rules = (ruleDefinition !== null && ruleDefinition.rules) ? ruleDefinition.rules.conditions : [];
            let schema = formDefinition.stepDefinitions[activeStep].dataSchema.schema;
            let uiSchema = formDefinition.stepDefinitions[activeStep].uiSchema.schema;
            let engine = new Engine(rules);
            FormWithConditionals = applyRules(schema, uiSchema, rules, engine, sdkForms.customRuleActions)(Form);
            let updateState = true;
            jsonEngineFunc((state.payloadData) ? state.payloadData : formData, updateState);
        }

    }, [formDefinition, activeStep])
    // get brand name based on uri
    useEffect(() => {
        if (payloadData && !payloadData.brand) {
            const brand = getBrand();
            const updatedPayloadData = {...payloadData};
            const brandId = brand ? window.environmentConfig.brandToThemeMap[brand] ? window.environmentConfig.brandToThemeMap[brand].brandId : brand : window.environmentConfig.brandToThemeMap.default.brandId;
            updatedPayloadData.brand = brandId;
            if (updatedPayloadData.data) {
                updatedPayloadData.data.brand = brandId;
            }
            getThemesByBrand(brand);
            setState(prevState => ({
                ...prevState,
                payloadData: {...updatedPayloadData, data: {...updatedPayloadData.data}}
            }));
        }
    }, [setState, payloadData])

    const handleSubmit = () => {
        const formValidation = validateFormData(payloadData.data, formRef.current.state.schema, customFormValidation, transformErrors, undefined, customFormats);
        if (isArrEmpty(formValidation.errors)) {
            //If form doesn't have summary i.e a Simple form OR Stepped form withot summary, we remove hidden elements before submit.
            if(!doesFormContainSummary(formDefinition)){
                const currentStepFormData = getCurrentStepFormData(payloadData.data, formRef.current.state.schema.properties);
                const updatedFormData = sdkForms.removeHiddenFieldsFromFormData(currentStepFormData, formDefinition.stepDefinitions[activeStep].dataSchema.schema, formRef.current.state.schema, payloadData);
                payloadData.data=updatedFormData;
            }
            payloadData.data.isSubmitted = true;
            let custDetails = {...customerDetails};
            // Removing the empty or null values from the customer details to prevent storing the empty values into the DB
            custDetails = Object.fromEntries(Object.entries(custDetails).filter(([_, value]) => value !== null && value !== "" && value !== undefined));
            payloadData.data = {...payloadData.data, ...custDetails};
            const newPayload = omit(payloadData, ['uuid']);
            onAnalyticsApplicationSubmit(defaultBasicTag, submitDataTag)
            setState(prevState => ({ ...prevState, submitData: { ...newPayload, ...payloadData }, isDataSaved: false, isLiveValidate: false }))
            setFormSubmitted(true);
        } else {
            focusFirstErrorField(formValidation.errorSchema);
            setState(prevState => ({
                ...prevState,
                isLiveValidate: true
            }))
        }
    }

    useEffect(() => {
        if (response && isThankyouPage) {
            let thankyouData = {};
            // Get thankyou page component data
            for (let key in payloadData.data) {
                if (!submitData.data.hasOwnProperty(key)) {
                    thankyouData[key] = payloadData.data[key];
                }
            }

            // To check if the field has been removed/cleared from thankyou page by user then is need to be removed from thankyouData also.
            for (let key in thankyouData){
                if(!payloadData.data.hasOwnProperty(key) || !payloadData.data[key]){
                    delete thankyouData[key]; 
                }
            }
            let formData = { ...submitData.data, thankyouPageData: thankyouData };
            setThankyouPagePayloadData({ ...submitData, data: formData, uuid: response.uuid });
        }
    }, [payloadData]);

    useEffect(() => {
        if (isThankyouPage && isSendFeedback) {
            const formValidation = validateFormData(payloadData.data, formRef.current.state.schema, customFormValidation, transformErrors, undefined, customFormats);
            if (isArrEmpty(formValidation.errors)) {
                if (isObjectEmpty(thankyouPagePayloadData.data.thankyouPageData)) {
                    setIsSendFeedback(false);
                    return;
                }
                let aborted = false;
                setSendFeedbackApiState({ isSaving: true, error: null, response: undefined });
                sendFeedbackApi({
                    method: 'put',
                    accept: 'json',
                    body: thankyouPagePayloadData
                }, thankyouPagePayloadData).then((res) => {
                    if (!aborted) {
                        setSendFeedbackApiState({ isSaving: false, response: res.body });
                    }
                })
                    .catch(error => {
                        !aborted && setSendFeedbackApiState({ isSaving: false, error: error })
                    })
                setState(prevState => ({
                    ...prevState,
                    isLiveValidate: false
                }))
            } else {
                focusFirstErrorField(formValidation.errorSchema);
                setState(prevState => ({
                    ...prevState,
                    isLiveValidate: true
                }));
            }
            setIsSendFeedback(false);
        }
    },[isSendFeedback && thankyouPagePayloadData])

    const handleSendFeedback = () => {
        setIsSendFeedback(true);
    }

    const updateFormData = (formData, schema) => {
        
        const newFormState = {
            schema: schema || JSON.parse(JSON.stringify(formDefinition.stepDefinitions[activeStep].dataSchema.schema)),
            uiSchema: JSON.parse(JSON.stringify(formDefinition.stepDefinitions[activeStep].uiSchema.schema)),
            formData: formData,
            formRules: formDefinition.stepDefinitions[activeStep].ruleDefinition?.rules
        }

        setState(prevState =>
            ({
                ...prevState,
                formState: newFormState,
                formData: formData,
                payloadData: {
                    ...payloadData,
                    data: {
                        ...payloadData.data,
                        ...formData
                    },
                    formDefinitionReference: { uuid: formDefinition.uuid, version: formDefinition.version }
                }
            }));
    }

    /**
     * Callback added to the form context to be used by the custom validator. If an item in array has its
     * schema modified by a rule, specific to that item only, then we need to preserve a list of custom schemas
     * for array fields specific item indexes. This preserved map is set in the state and then passed in when
     * calling a customer validation
     * @param fieldName The name of the array field in the form that had its schema changed
     * @param itemIndex The index of the item in the array it occured to
     * @param formSchema    The updated form schema
     * @param uiSchema  The updated uiSchema
     */
    const onSubFormItemSchemaModifiedByRules = ( fieldName, itemIndex, formSchema, uiSchema ) => {
        console.debug( "Subform field ", fieldName, " item at index " + itemIndex + " has modified its schema to ", formSchema);

        let updatedCustomFieldArrayItemSchemaOverrides = {...customFieldArrayItemSchemaOverrides};
        if( !updatedCustomFieldArrayItemSchemaOverrides[fieldName] ) {
            updatedCustomFieldArrayItemSchemaOverrides[fieldName] = {};
        }
        updatedCustomFieldArrayItemSchemaOverrides[fieldName][itemIndex] = formSchema
        setCustomFieldArrayItemSchemaOverrides(updatedCustomFieldArrayItemSchemaOverrides);
    }

    const customFormValidation = (data,errors) =>  sdkForms.customFormValidator(data,errors,formState.uiSchema,formRef.current.state.schema, customFieldArrayItemSchemaOverrides);

    /**
 * Checks the specified form context for the presence of a summary widget and if the formData
 * within for the summary page has the 'howWeUseData' check box ticked. If it is NOT checked then
 * we set a flag disable the next / submit button
 */
    useEffect(() => {
        if (payloadData.data && formDefinition) {
            const currentDataSchema = formDefinition.stepDefinitions[activeStep].dataSchema.schema;
            if(!isObjectEmpty(currentDataSchema)) {
                const summaryWidgetFieldName = Object.keys(currentDataSchema.properties).find(key => currentDataSchema.properties[key].widget === WIDGET_SUMMARY);
                if (summaryWidgetFieldName && currentDataSchema.properties[summaryWidgetFieldName].howWeUseData && payloadData.data[summaryWidgetFieldName]?.howWeUseData !== true) {
                    setIsNextButtonDisabled(true);
                } else {
                    setIsNextButtonDisabled(false);
                }
            }
        }
    }, [activeStep, payloadData])    

    useEffect(() => {
        if (payloadData) {
            jsonEngineFunc( payloadData );
        }
    }, [formState]);

    useEffect(() => {
        if (formDefinition && formData) {
            if (!isDataSaved) {
                setState(prevState => ({
                    ...prevState,
                    formState: {
                        schema: JSON.parse(JSON.stringify(formDefinition.stepDefinitions[activeStep].dataSchema.schema)),
                        uiSchema: JSON.parse(JSON.stringify(formDefinition.stepDefinitions[activeStep].uiSchema.schema)),
                        formData: formData.data,
                        formRules: formDefinition.stepDefinitions[activeStep].ruleDefinition?.rules
                    },
                    payloadData: {
                        ...prevState.payloadData,
                        ...formData,
                        data: (!isUpdateSubmitForm && formId) ? {...formData.data} : {...prevState.formData, ...prevState.payloadData.data},
                        formDefinitionReference: { uuid: formDefinition.uuid, version: formDefinition.version }
                    }
                }));
            } else {
                setState(prevState => ({
                    ...prevState,
                    formState: {
                        schema: JSON.parse(JSON.stringify(formDefinition.stepDefinitions[activeStep].dataSchema.schema)),
                        uiSchema: JSON.parse(JSON.stringify(formDefinition.stepDefinitions[activeStep].uiSchema.schema)),
                        formData: formData.data,
                        formRules: formDefinition.stepDefinitions[activeStep].ruleDefinition?.rules
                }
                }));
                window.scrollTo(0,0);
            }
        }
    }, [setState, isRulesByBrand, formData, activeStep])

    useEffect(() => {
        if (response) {
            setState(prevState => ({
                ...prevState, payloadData: { ...prevState.payloadData, ...response }, isDataSaved: true, isThankyouPage: true,
                activeStep: formDefinition.stepDefinitions.length - 1
            }));
            analyticsApplicationComplete(defaultBasicTag, response)
        }
    }, [setState, response]);


    function compare(a, b) {
        const compA = a.sequenceNumber;
        const compB = b.sequenceNumber;

        let comparison = 0;
        if (compA > compB) {
            comparison = 1;
        } else if (compA < compB) {
            comparison = -1;
        }
        return comparison;
    }

    const onStepNextClick = (seqNumber) => {
        headerRef.current.setAttribute('tabindex', '0');
        window.scrollTo(0, 0);
        headerRef.current.focus();
        
        const currentStepFormData = getCurrentStepFormData(payloadData.data, formRef.current.state.schema.properties);
        // To avoid making change to the original schema, this duplicate schema variable is created  
        const duplicateSchema = cloneDeep(formRef.current.state.schema);
        removeDefaultProperties(currentStepFormData, duplicateSchema.properties);
        var formValidation = validateFormData( currentStepFormData, duplicateSchema, customFormValidation, transformErrors, undefined, customFormats );
        if (!(formValidation.errors && formValidation.errors.length > 0) || seqNumber < activeStep) {
            const updatedFormData = sdkForms.removeHiddenFieldsFromFormData(currentStepFormData, formDefinition.stepDefinitions[activeStep].dataSchema.schema, formRef.current.state.schema, payloadData);

            setState(prevState => ({
                ...prevState,
                completedStep: true,
                activeStep: seqNumber,
                isLiveValidate: false,
                isUpdateSubmitForm: true,
                formData: updatedFormData,
                payloadData: {
                    ...payloadData,
                    data: { ...updatedFormData }
                }
            }))
            analyticsApplicationStepName(formDefinition, seqNumber, defaultBasicTag)

        } else {
            focusFirstErrorField(formValidation.errorSchema);
            setState(prevState => ({
                ...prevState,
                isLiveValidate: true,
            }))
            const newAnalyticsData = cloneDeep(submitDataTag);
            const stepName = formDefinition.stepDefinitions[activeStep].name;
            const brandName = state.payloadData.brand;
            const applicationObjectData = { 
                application: {
                    ...defaultBasicTag.application,
                    stepName: stepName,
                    brandName: brandName,
                    applicationType: document.title
                }
             };            
            updateAnalyticsErrorMessage(formValidation.errors, newAnalyticsData, formState, applicationObjectData);
        }
    }

    const onGoBack = (seqNumber) => {
        window.scrollTo(0, 0);
        headerRef.current.focus();
        setState(prevState => ({
            ...prevState,
            completedStep: true,
            activeStep: seqNumber,
            isLiveValidate: false,
        }))
        analyticsApplicationStepName(formDefinition, seqNumber, defaultBasicTag)
    }

    const transformErrors = (errors) => {
        cloneDeep(submitDataTag);
        return sdkForms.customTransformErrors(formDefinition, state.activeStep, errors, undefined, payloadData.data);
    }

    //TODO: This hole function needs to be re-wrritten as common function so that can be used
    // In both Editor, Runtime internal and external
    function jsonEngineFunc(formData, updateState) {
        // dynamic json rule;
        if (formDefinition && formDefinition.ruleDefinition) {
            let ruleDefinition = formDefinition.ruleDefinition;
            let JsonRules = (ruleDefinition !== null && ruleDefinition.rules) ? ruleDefinition.rules.conditions : [];
            JsonRules = JsonRules.filter( ( item ) => item.conditions.stepName === formDefinition.stepDefinitions[activeStep].name || item.conditions.stepName?.toLowerCase() === 'all');
            JsonRules.forEach(item => {
                let jsonengine = new JsonEngine();
                jsonengine.addOperator('empty', (factValue) => {
                    if (factValue && !factValue.length) return false
                    return (!factValue || factValue === "")
                })
                jsonengine.addOperator('notEmpty', (factValue, jsonValue) => {
                    if (!factValue) return false
                    return factValue !== jsonValue
                })
                let showButton = JSON.parse(JSON.stringify(item).replace(/\uFF04/g, '$').replace(/\uFF0E/g, '.'));

                jsonengine.addRule(showButton)

                jsonengine.addFact('form-data', () => formData);
                let facts = { formData: formData }
                jsonengine.run(facts).then(({ events }) => {
                    events.forEach(event => {
                        if (stepName) {
                            for (let i = 0; i < formDefinition.stepDefinitions.length; i++) {
                                let index = formDefinition.stepDefinitions[i].name.indexOf(stepName);
                                if (index !== -1) {
                                    state.activeStep = i;
                                }
                            }
                        }
                        if (event.type === 'hideSteps') {
                            hideStepsFun( event )
                        } else if (event.type === 'showSteps') {
                            showStepsFun( event )
                        } else if (event.type === 'status') {
                            UpdateStatus(event)
                        } else if (event.type === 'autoPopulate') {
                            autoPopulateElement(event)
                        } else if (event.type === 'enableRulesByBrand') {
                            enableRulesByBrand(event)
                        }
                    })
                })
            })
        }
    }

    //TODO: Have made changes as per the Internal runtime UI, however we need to make all these function as common to reduce the bugs only in some service

    const hideStepsFun = ( event ) => {
        if ( event.type === 'hideSteps' ) {
            if ( !isArrEmpty( event.params.steps ) ) {
                let updatedFormData = cloneDeep(payloadData.data);
                let updatedDataDictionary = {...dataDictionary};
                let updateState = false;
                event.params.steps.map( ( step ) => {
                    const removedStep = formDefinition.stepDefinitions.filter( ( removedStep ) => removedStep.name === step );
                    if ( !isArrEmpty( removedStep ) ) {
                        const removeStep = removedStep[0];
                        //Adding each fields of removed steps into dataDictionary in key value pairs
                        Object.keys(removeStep.dataSchema.schema.properties).map((field) => {
                            if(updatedFormData[field] && !updateState) {
                                updateState = true;
                            }
                            updatedDataDictionary[field]=updatedFormData[field];
                            return delete updatedFormData[field];
                        })
                        removedSteps.push( removedStep[0] );
                        var index = formDefinition.stepDefinitions.findIndex( item => item.name === step );
                        formDefinition.stepDefinitions.splice( index, 1 )
                    }
                } )
                setRemovedSteps( [...removedSteps] )
                 //Removing hidden steps field data from PayloadData.data
                 if(updateState){
                    setState((prevState)=>{
                        let newState = {...prevState}
                        newState.payloadData.data = updatedFormData;
                        return newState;
                    })
                 }
                setDataDictionary(prev=>{
                    let newState={...prev,...updatedDataDictionary};
                    return newState;
                });
                if ( !ishideSteps ) {
                    setIsHideStep( true )
                } else {
                    setIsHideStep( false );
                }
            }
        }
    };
    const showStepsFun = ( event ) => {
        if ( event.type === 'showSteps' ) {
            if ( !isArrEmpty( event.params.steps ) ) {
                let updatedFormData = cloneDeep(payloadData.data)
                let updateState = false;
                event.params.steps.map( ( step ) => {
                    const removedStep = removedSteps.filter( ( removedStep ) => removedStep.name === step );
                    if ( !isArrEmpty( removedStep ) ) {
                        const removeStep = removedStep[0];
                        //Updating formData with newly visible fields from dataDictionary
                        Object.keys(removeStep.dataSchema.schema.properties).map((field) => {
                            if(updatedFormData[field] && !updateState) {
                                updateState = true;
                            }
                            updatedFormData[field] = dataDictionary[field];                            
                        })
                        formDefinition.stepDefinitions.push( removedStep[0] );
                        var index = removedSteps.findIndex( item => item.name === step );
                        removedSteps.splice( index, 1 )
                    }
                } )
                setRemovedSteps( [...removedSteps] )
                if(updateState) {
                    setState((prevState)=>{
                        let newState = {...prevState}
                        newState.payloadData.data = updatedFormData;
                        return newState;
                    })
                }
                if ( ishideSteps ) {
                    setIsHideStep( false );
                } else {
                    setIsHideStep( true );
                }
            }
        }
    };

    const UpdateStatus = (event) => {
        if (event.type === 'status') {
            state.payloadData.status = event.params.value;
            state.payloadData.status = event.params.value;
        }
    }

    const autoPopulateElement = (event) => {
        if (event.type === 'autoPopulate') {
            event.params.forEach(param => {
                if ((state.payloadData.data[param.to] !== state.payloadData.data[param.from]) && (state[`${param.from}_step`] === activeStep || state[`${param.from}_step`] === undefined)) {
                    state.payloadData.data[param.to] = state.payloadData.data[param.from];
                    state[`${param.from}_step`] = activeStep;
                }
            });
        }
    }

    const enableRulesByBrand = (event) => {
        if (event.type === 'enableRulesByBrand') {
            if (event.params.enable) {
                if (formData && formData.data && !formData.data.brand) {
                    setState(prevState => ({
                        ...prevState,
                        isRulesByBrand: true
                    }))
                    formData.data.brand = payloadData.brand;
                }
            }
        }
    }

    useEffect(() => {
        const setFormColumnLayout = () => {
            if (window.innerWidth > 840 && window.innerWidth < 1256) {
                setNoOfColumnsForStepper(4);
                setNoOfColumnsForForm(8);
            }
            else {
                setNoOfColumnsForStepper(3);
                setNoOfColumnsForForm(9);
            }
        };
        window.addEventListener('resize', setFormColumnLayout);
        setFormColumnLayout();
        const setStickyStepperPosition = () => {
            let scrollDistanceBeforeSticking    = document.querySelector('.zb-masthead-container').offsetHeight;
            let userScrollDistance              = window.pageYOffset;
            const mobileFormStepper             = document.querySelector('.steps-nav-container.mobile');
            if (!mobileFormStepper) { return false; }
           mobileFormStepper.dataset.isSticky  = (userScrollDistance >= scrollDistanceBeforeSticking) ? 'true' : 'false';
        };
        window.addEventListener('scroll', setStickyStepperPosition);
        setStickyStepperPosition();
    }, [] );

    // Cancel session renewal timer and reset state to initial value if there is any error
    useEffect(() => {
      if (schemaError || authenticationError) {
        clearInterval(renewalTimerId);
        sessionStorage.clear();
        setState({
          isDataSaved: false,
          ishideSteps: false,
          isRulesByBrand: false,
          isUpdateSubmitForm: false,
          isLiveValidate: false,
          activeStep: 0,
          payloadData: { data: {} },
          thankyou: {},
          completedStep: false,
          removedSteps: [],
          isShowButton: false,
          isThankyouPage: false,
          isOpen: true,
          isModelOpen: false,
          parentUuid: "",
        });
      }
    }, [schemaError, authenticationError]);

    // Cancel session renewal timer and clear session depending upon once form is submitted or feedback submitted
    useEffect(() => {
        const clearSessionStorage = () => {
            clearInterval(renewalTimerId);
            sessionStorage.clear();
        }

        if (formDefinition) {
            const thankYouPage = formDefinition.stepDefinitions.find(item => item.name === THANK_YOU_PAGE_TEXT);
            const hasThankYouPage = !!thankYouPage;
            
            if ((hasThankYouPage && sendFeedbackApiState.response) || 
                (!hasThankYouPage && formSubmitted)) {
                clearSessionStorage();
            }
        }
        
    }, [formSubmitted, sendFeedbackApiState]);

    const renderMainContent = () => {
        return (
            <div>
                {formDefinition && formDefinition.isSteppedForm &&
                    <nav className="zb-column-is-3 steps-nav-container mobile zb-is-visible-mobile-block" data-is-sticky="false">
                        <div className="zb-flex step-header">
                            <div className="step-circle">
                                <span className="">{activeStep + 1} of {formDefinition.stepDefinitions.length}</span>
                            </div>
                            <div className="step-title zb-flex zb-flex-column">
                                <span className="first-step">{formDefinition.stepDefinitions.sort(compare)[activeStep].name}</span>
                                <span className="next-step">{(activeStep + 1) < formDefinition.stepDefinitions.length && `Next: ${formDefinition.stepDefinitions.sort(compare)[activeStep + 1].name}`}</span>
                            </div>
                        </div>
                    </nav>
                }
                <div className='zb-container'>
                    <div className="zb-columns">
                        {formDefinition && formDefinition.isSteppedForm && !state.isThankyouPage &&
                            <nav className={`zb-column-is-${noOfColumnsForStepper} steps-nav-container full zb-is-visible-widescreen-block zb-is-visible-tablet-block zb-is-visible-desktop-block`}>
                                {activeStep > 0 && <a href="#" className="back-link tablet-only" onClick={(e) => { e.preventDefault(); onGoBack(activeStep - 1, formState); }}><Icon name="chev-left-xsmall" title="Back" aria-hidden="true" /> {'Back'}</a>}
                                <section className='zb-card'>
                                    <header className='zb-card-header'>
                                        <h2 className='zb-card-header-title'>Steps</h2>
                                    </header>
                                    <div className='zb-card-body'>
                                        <ul>
                                            {formDefinition && formDefinition.stepDefinitions && formDefinition.stepDefinitions.sort(compare).map((item, index) => {
                                                if (item.name !== THANK_YOU_PAGE_TEXT) {
                                                    return (
                                                        <li key={index} data-step-complete={index < activeStep} data-active-step={activeStep === index}>
                                                            {
                                                                index < activeStep ?
                                                                    <div className="step-number">
                                                                        <Icon
                                                                            name="confirmation-small"
                                                                            size="large"
                                                                            aria-hidden
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <div className={`zb-icon step-number zb-icon-large step-number-icon`} style={{ flexShrink: '0' }}>
                                                                        {index + 1}
                                                                    </div>
                                                            }
                                                            <div className="step-title" >{item.name}{item.sequenceNumber < activeStep ? <span className="accessibleHidden">Completed</span> : ''}</div>
                                                        </li>
                                                    )
                                                } else {
                                                        return undefined;
                                                    }
                                            })}
                                        </ul>
                                    </div>
                                </section>
                            </nav>
                        }
                        {state.isThankyouPage && response &&
                            <div className='zb-column-is-12'>
                                <span role='alert' className="accessibleHidden">
                                    {!sendFeedbackApiState.response ? FORM_SUBMIT_ACKNOWLEDGEMENT : FEEDBACK_SUBMIT_ACKNOWLWDGEMENT}
                                </span>
                                <Notification status='success' >
                                    {!sendFeedbackApiState.response ? FORM_SUBMIT_ACKNOWLEDGEMENT : FEEDBACK_SUBMIT_ACKNOWLWDGEMENT}
                                </Notification>
                            </div>
                        }
                        <main className={(formDefinition && formDefinition.isSteppedForm && (!state.isThankyouPage)) ? `zb-column-is-${noOfColumnsForForm}` : 'zb-column-is-12'}>
                            {activeStep > 0 && !state.isThankyouPage &&
                                <a href="#" className="back-link" onClick={(e) => { e.preventDefault(); onGoBack(activeStep - 1, formState); }}>
                                    <Icon name="chev-left-xsmall" title="Back" aria-hidden="true" />
                                    Back
                                </a>
                            }
                            <section className='zb-card'>
                                {formDefinition && (formDefinition.isSteppedForm || state.isThankyouPage) &&
                                    <header className='zb-card-header'>
                                        <h2 className='zb-card-header-title' ref={headerRef} role='heading'>
                                            {formDefinition && formDefinition.isSteppedForm ?
                                                formDefinition?.stepDefinitions[state.activeStep]?.name.replace('Thank you page','Thank you') :
                                                state.thankyou && state.thankyou?.length > 0 ?
                                                state.thankyou[0].name :
                                                'Thank you'
                                            }
                                            {typeof(payloadData) === 'undefined' ?
                                                '' :
                                                typeof(payloadData.version) === 'undefined' ?
                                                '' :
                                                'v' + payloadData.version
                                            }
                                        </h2>
                                    </header>
                                }
                                <div className='zb-card-body'>
                                    {renderContent()}
                                </div>
                            </section>
                            {displayFormButtons()}
                        </main>
                    </div>
                </div>
            </div >
        )
    }

    return (
        <div>
            <div className='App-main-x'>
                <header className="zb-masthead-container" role="banner">
                    <div className="zb-masthead preview-masterhead">
                        <span className={brandDetails?.cssClass ? brandDetails.cssClass : null} role="img" aria-label={brandDetails?.label ? brandDetails.label : null} />
                        <h1 className="zb-masthead-brand-name">{formDefinition && formDefinition.name}</h1>
                    </div>
                </header>
                <ScreenRenderingAssistant
                    contentRenderer={renderMainContent}
                    loadIsCompleted={() => !isSchemaLoading && formState}
                    error={(schemaError || authenticationError) ? {schemaError, authenticationError}: null }
                />
                <Modal
                    open={isModelOpen && isOpen}
                    title='Reference Number'
                    onCancel={() => setState(prevState => ({ ...prevState, isOpen: false, isModelOpen: false }))}
                >
                    <p className="zb-flex zb-flex-center">Reference Number: <b>{" "} {'formId'}</b></p>
                </Modal>
                <LimitedTimeWarningModal
                    shouldRender={authenticationStatus === AUTHENTICATION_STATUS.SUCCESS && !schemaError && !authenticationError && !formSubmitted}
                    isOpen={showLimitedTimeWarning}
                    onConfirm={() => 
                        updateAuthenticationDetails({
                        showLimitedTimeWarning: false,
                        })}
                    onSessionExpiry={() => 
                        updateAuthenticationDetails({
                        authenticationError: "SESSION_EXPIRED",
                        })}
                />
                <IdleFormExpiryModal
                    shouldRender={authenticationStatus === AUTHENTICATION_STATUS.SUCCESS && !schemaError && !authenticationError && !formSubmitted}
                    onSessionExpiry={() => 
                        updateAuthenticationDetails({
                        authenticationError: "INACTIVITY_ERROR",
                        })}
                />
                <Footer fullFooter={true} />
            </div>
        </div>
    )

    function displayFormButtons () {
        if (stepName !== THANK_YOU_PAGE_TEXT) {
            return (
                <>
                    {formDefinition?.stepDefinitions[activeStep]?.name !== THANK_YOU_PAGE_TEXT &&
                        <>
                            {formDefinition?.stepDefinitions[formDefinition.stepDefinitions.length - 1]?.name === THANK_YOU_PAGE_TEXT ?
                                <>
                                    {(formDefinition.isSteppedForm && activeStep === (formDefinition.stepDefinitions.length - 2)) || !formDefinition.isSteppedForm ?
                                        !formSubmitted && <button type='button' disabled={isNextButtonDisabled} className='zb-button zb-button-primary' tabIndex='0' onClick={() => handleSubmit()}>
                                            {"Submit"}
                                        </button> :
                                        <button type="button" disabled={isNextButtonDisabled} className='zb-button zb-button-primary' tabIndex='0' onClick={() => onStepNextClick(activeStep + 1)}>
                                            {"Next"}
                                        </button>
                                    }
                                </>
                                :
                                <>
                                    {(formDefinition.isSteppedForm && activeStep === (formDefinition.stepDefinitions.length - 1)) || !formDefinition.isSteppedForm ?
                                        !formSubmitted && <button type='button' disabled={isNextButtonDisabled} className='zb-button zb-button-primary' tabIndex='0' onClick={() => handleSubmit()}>
                                            {"Submit"}
                                        </button> :
                                        <button type="button" disabled={isNextButtonDisabled} className='zb-button zb-button-primary' tabIndex='0' onClick={() => onStepNextClick(activeStep + 1)}>
                                            {"Next"}
                                        </button>
                                    }
                                </>
                            }
                        </>
                    }
                </>
            )
        }
        else { return ''; }
    }

	/* As a a part of EFORMS-4338 defect fix , we are sending payload data with the response to access the form data in Thank you page 
	as previously only uuid details were sent when form submitted and we were not able to access any form field in the Thank you page */
    function renderContent() {
        if (formState) {
            const formContext = (response && {...payloadData, response, submitData: submitData, sendFeedbackApiState: sendFeedbackApiState, handleSendFeedback:handleSendFeedback}) || { ...payloadData, 'parentUuid': (parentUuid) ? parentUuid : formData.id, liveValidate: isLiveValidate, onSubFormItemSchemaModifiedByRules: onSubFormItemSchemaModifiedByRules, customFieldArrayItemSchemaOverrides: customFieldArrayItemSchemaOverrides };
            formContext.analyticsChange = handleAnalyticsChange;
            return (
                <>
                    <FormWithConditionals
                        liveValidate={isLiveValidate}
                        validate={customFormValidation}
                        widgets={widgets}
                        fields={extendedFields}
                        ErrorList={ErrorList}
                        uiSchema={formState.uiSchema}
                        schema={formState.schema}
                        formData={payloadData.data}
                        transformErrors={transformErrors}
                        formContext={formContext}
                        onBlur={(data) => { if(isObject(data)) { updateFormData(data) }}}
                        ref={formRef}
                        onChange={(form,schema,uiSchema) => updateFormData(form.formData,schema)}
                        customFormats={customFormats}
                        children={true}
                        id="eforms-rjsf"
                        idPrefix={sdkForms.formConstant.FORM_ID_PREFIX}
                        >
                    </FormWithConditionals>
                </>
            )
        } else {
            return <Notification>Form not found!</Notification>
        }
    }

}
